import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-switch.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSFavoriteSwitch extends React.Component {
  static displayName = 'EGDSFavoriteSwitch';
  static defaultProps = {
    checked: false
  };
  render() {
    const {
      checked,
      className,
      disabled,
      id,
      label,
      labelClassName,
      name,
      onChange,
      value
    } = this.props;
    const baseClass = 'uitk-favorite-switch';
    const wrapperClassName = getClassNameList(baseClass, {
      'is-disabled': disabled
    });
    const inputClassNames = getClassNameList(className, `${baseClass}-input`);
    const labelCssClassName = getClassNameList(labelClassName, `${baseClass}-control`, {
      [`${baseClass}-input-is-checked`]: checked
    });
    const fillCssClassName = getClassNameList(`${baseClass}-fill`);
    const borderCssClassName = getClassNameList(`${baseClass}-border`);
    return jsx("div", {
      className: wrapperClassName,
      children: jsxs("label", {
        className: labelCssClassName,
        htmlFor: id,
        children: [jsx("input", {
          className: inputClassNames,
          type: "checkbox",
          name: name || id,
          id: id,
          checked: checked,
          onChange: onChange,
          value: value,
          "aria-label": label,
          disabled: disabled
        }), jsx(EGDSIcon, {
          name: "favorite",
          className: fillCssClassName
        }), jsx(EGDSIcon, {
          name: "favorite_border",
          className: borderCssClassName
        })]
      })
    });
  }
}
export { EGDSFavoriteSwitch };